import { useSyncExternalStore } from 'react'

/**
 * Beobachtet eine Media Query.
 *
 * Über `useSyncExternalStore` statt eines Effekts: Der Wert steht schon beim ersten
 * Rendern fest, sodass das Layout nicht kurz in der falschen Variante aufblitzt.
 * Beim Rendern auf dem Server liefert die Abfrage `false`.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (notify) => {
      const list = window.matchMedia(query)
      list.addEventListener('change', notify)
      return () => list.removeEventListener('change', notify)
    },
    () => window.matchMedia(query).matches,
    () => false,
  )
}
